export default data => {
  return {
    '@type': 'AboutPage',
    name: data?.title,
    description: data?.description,
    inLanguage: 'English',
    url: data?.canonicalUrl,
  };
};
